import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock, Download } from 'lucide-react';
const includes = ['E-book completo 33 módulos', 'Plan de 21 días paso a paso', 'Resumen visual de los 21 días', 'Plan de mantenimiento permanente', 'Descarga inmediata en PDF'];
export const PricingSection: React.FC = () => {
  return <section id="pricing" className="py-20 lg:py-28 bg-white" data-id="element-87">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-88">
        <motion.div className="text-center max-w-3xl mx-auto mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-89">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-charcoal" data-id="element-90">
            Tu inversión hoy
          </h2>
        </motion.div>

        <motion.div className="max-w-lg mx-auto bg-white rounded-3xl border-2 border-brand-lightmint shadow-xl overflow-hidden" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-91">
          <div className="p-8 sm:p-10 text-center bg-brand-lightmint/30" data-id="element-92">
            <div className="inline-block mb-2" data-id="element-93">
              <span className="text-xl text-gray-400 line-through font-medium" data-id="element-94">
                $27
              </span>
            </div>
            <div className="text-6xl font-bold text-brand-emerald mb-4 tracking-tight" data-id="element-95">
              $9.99
            </div>
            <p className="text-lg font-medium text-brand-charcoal" data-id="element-96">
              Pago único — Acceso inmediato
            </p>
          </div>

          <div className="p-8 sm:p-10" data-id="element-97">
            <ul className="space-y-4 mb-10" data-id="element-98">
              {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-99">
                  <CheckCircle2 className="w-6 h-6 text-brand-emerald flex-shrink-0" data-id="element-100" />
                  <span className="text-gray-700 font-medium" data-id="element-101">{item}</span>
                </li>)}
            </ul>

            <a href="https://go.hotmart.com/L105883257P" target="_blank" rel="noopener noreferrer" className="block w-full py-4 px-6 text-center text-lg font-bold text-white bg-brand-emerald hover:bg-brand-emeraldHover rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 mb-6" data-id="element-102">
              SÍ, QUIERO RESETEAR MI CORTISOL — $9.99
            </a>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-sm text-gray-500 font-medium" data-id="element-103">
              <div className="flex items-center gap-2" data-id="element-104">
                <Lock className="w-4 h-4 text-brand-emerald" data-id="element-105" />
                <span data-id="element-106">Pago 100% seguro</span>
              </div>
              <div className="hidden sm:block text-gray-300" data-id="element-107">|</div>
              <div className="flex items-center gap-2" data-id="element-108">
                <Download className="w-4 h-4 text-brand-emerald" data-id="element-109" />
                <span data-id="element-110">Descarga inmediata</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};